export default "__VITE_ASSET__YRTl6h$M__"